<template>
  <div class="bg-white w-full rounded-lg my-3 px-4 py-2.5">
    <nav aria-label="breadcrumb">
      <ol class="flex items-center mb-2.5 gap-2.5 leading-none">
        <template v-if="items.length === 1">
          <li class="active text-gray-700 text-sm font-medium capitalize">{{ items[0].label }}</li>
        </template>
        <template v-else-if="items.length === 2">
          <li>
            <router-link :to="items[0].to" class="text-gray-700 text-sm font-medium capitalize">{{ items[0].label }}</router-link>
          </li>
          <li class="text-gray-400 text-xs font-normal">
            <i class="fa-solid fa-chevron-right"></i>
          </li>
          <li class="text-gray-500 font-medium text-sm capitalize">{{ items[1].label }}</li>
        </template>
        <template v-else>
          <li v-for="(item, idx) in items" :key="idx" class="flex items-center">
            <template v-if="idx < items.length - 1">
              <router-link :to="item.to" class="active text-gray-700 text-sm font-medium capitalize">{{ item.label }}</router-link>
              <span class="mx-2 text-gray-500 text-xs font-normal"><i class="fa-solid fa-chevron-right"></i></span>
            </template>
            <template v-else>
              <span class="text-gray-500 font-normal capitalize">{{ item.label }}</span>
            </template>
          </li>
        </template>
      </ol>
    </nav>
    <h4 class="text-xl font-semibold text-gray-900 m-0 capitalize">{{title}}</h4>
  </div>
</template>

<script>
export default {
  name: 'HeaderBreadcrumbs',
  props: {
    items: {
      type: Array,
      required: true,
      // [{ label: 'Home', to: '/' }, { label: 'Detail' }]
    },
    title: {
      type: String,
      default: '',
    },
  }
}
</script>
